import { useEffect, useReducer, useCallback } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/header";
import { friendspage } from "../../functions/reducers";
import { getFriendsPageInfos } from "../../functions/user";
import Card from "./Card";
import Birthdays from "./Birthdays";
import Suggestions from "./Suggestions";
import CustomLists from "./CustomLists";
import "./style.css";
export default function Friends() {
  const { user } = useSelector((state) => ({ ...state }));
  const { type } = useParams();

  const [{ loading, error, data }, dispatch] = useReducer(friendspage, {
    loading: false,
    data: {},
    error: "",
  });

  const getData = useCallback(async () => {
    try {
      dispatch({ type: "FRIENDS_REQUEST" });
      const response = await getFriendsPageInfos(user.token);
      if (response.status === "ok") {
        dispatch({ type: "FRIENDS_SUCCESS", payload: response.data });
      } else {
        dispatch({ type: "FRIENDS_ERROR", payload: response.data });
      }
    } catch (err) {
      dispatch({ type: "FRIENDS_ERROR", payload: "Failed to fetch friends data" });
    }
  }, [user.token, dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  if (loading) {
    return (
      <>
        <Header page="friends" />
        <div className="friends">
          <div className="friends_left">
            <div className="friends_left_header">
              <h3>Friends</h3>
            </div>
          </div>
          <div className="friends_right">
            <div className="loading">Loading friends...</div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header page="friends" />
        <div className="friends">
          <div className="friends_left">
            <div className="friends_left_header">
              <h3>Friends</h3>
            </div>
          </div>
          <div className="friends_right">
            <div className="error">Error: {error}</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header page="friends" />
      <div className="friends">
        <div className="friends_left">
          <div className="friends_left_header">
            <h3>Friends</h3>
            {/* <div className="small_circle">
              <i className="settings_filled_icon"></i>
            </div> */}
          </div>
          <div className="friends_left_wrap">
            <Link
              to="/friends"
              className={`mmenu_item hover3 ${
                type === undefined && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_home_icon "></i>
              </div>
              <span>Home</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/requests"
              className={`mmenu_item hover3 ${
                type === "requests" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_requests_icon"></i>
              </div>
              <span>Friend Requests</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/sent"
              className={`mmenu_item hover3 ${
                type === "sent" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_requests_icon"></i>
              </div>
              <span>Sent Requests</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/suggestions"
              className={`mmenu_item hover3 ${
                type === "suggestions" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="friends_suggestions_icon"></i>
              </div>
              <span>Suggestions</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/all"
              className={`mmenu_item hover3 ${
                type === "all" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="all_friends_icon"></i>
              </div>
              <span>All Friends</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/birthdays"
              className={`mmenu_item hover3 ${
                type === "birthdays" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="birthdays_icon"></i>
              </div>
              <span>Birthdays</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
            <Link
              to="/friends/custom-lists"
              className={`mmenu_item hover3 ${
                type === "custom-lists" && "active_friends"
              }`}
            >
              <div className="small_circle">
                <i className="all_friends_icon"></i>
              </div>
                              <span>Groups</span>
              <div className="rArrow">
                <i className="right_icon"></i>
              </div>
            </Link>
          </div>
        </div>
        <div className="friends_right">
          {type === "birthdays" && (
            <Birthdays />
          )}
          {type === "suggestions" && (
            <Suggestions />
          )}
          {type === "custom-lists" && (
            <CustomLists />
          )}
          {(type === undefined || type === "requests") && (
            <div className="friends_right_wrap">
              <div className="friends_left_header">
                <h3>Friend Requests</h3>
                {type === undefined && (
                  <Link to="/friends/requests" className="see_link hover3">
                    See all
                  </Link>
                )}
              </div>
              <div className="flex_wrap">
                {data.requests && data.requests.length > 0 ? (
                  data.requests.map((user) => (
                    <Card
                      userr={user}
                      key={user._id}
                      type="request"
                      getData={getData}
                    />
                  ))
                ) : (
                  <div className="no_data">No friend requests</div>
                )}
              </div>
            </div>
          )}
          {(type === undefined || type === "sent") && (
            <div className="friends_right_wrap">
              <div className="friends_left_header">
                <h3>Sent Requests</h3>
                {type === undefined && (
                  <Link to="/friends/sent" className="see_link hover3">
                    See all
                  </Link>
                )}
              </div>
              <div className="flex_wrap">
                {data.sentRequests && data.sentRequests.length > 0 ? (
                  data.sentRequests.map((user) => (
                    <Card
                      userr={user}
                      key={user._id}
                      type="sent"
                      getData={getData}
                    />
                  ))
                ) : (
                  <div className="no_data">No sent requests</div>
                )}
              </div>
            </div>
          )}
          {(type === undefined || type === "all") && (
            <div className="friends_right_wrap">
              <div className="friends_left_header">
                <h3>Friends</h3>
                {type === undefined && (
                  <Link to="/friends/all" className="see_link hover3">
                    See all
                  </Link>
                )}
              </div>
              <div className="flex_wrap">
                {data.friends && data.friends.length > 0 ? (
                  data.friends.map((user) => (
                    <Card
                      userr={user}
                      key={user._id}
                      type="friends"
                      getData={getData}
                    />
                  ))
                ) : (
                  <div className="no_data">No friends found</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
